const form = document.querySelector(".calcForm");
const aside = document.querySelector(".calculatorResults");
const formBtn = document.querySelector(".calcSubmit");
const maintenance = document.querySelector(".calcResultsHead");
const warning = document.querySelector(".warning");
const fatMass = document.querySelector(".bodyFatResultsRow.fat");
const leanMass = document.querySelector(".bodyFatResultsRow.lean");
const waterMass = document.querySelector(".bodyFatResultsRow.water");

let previousFormData = {};

form.querySelector("#gender").addEventListener("change", (e) => {
  if (e.currentTarget.value == "female") {
    form.querySelector(".calcCell.womenHip").style.display = "block";
  } else {
    form.querySelector(".calcCell.womenHip").style.display = "none";
  }
});

// Fat mass = BF * mass
// Lean mass = mass X (1 - BF)
// Water mass = .73

formBtn.addEventListener("click", (e) => {
  e.preventDefault();
  const formData = {
    age: form.querySelector("#age").value,
    inches: form.querySelector("#inches").value,
    weight: form.querySelector("#weight").value,
    gender: form.querySelector("#gender").value,
    waist: form.querySelector("#waist").value,
    neck: form.querySelector("#neck").value,
    hip: form.querySelector("#hip").value,
  };

  // Check if the form data has changed
  if (JSON.stringify(formData) === JSON.stringify(previousFormData)) {
    console.log("Data has not changed.");
    return; // Exit early if data hasn't changed
  }

  if (formData.weight < 1) {
    showWarning("Enter a weight above 0");
    return;
  }
  if (formData.waist < 1) {
    showWarning("Enter a weight above 0");
    return;
  }
  if (formData.neck < 1) {
    showWarning("Enter a weight above 0");
    return;
  }
  if (formData.hip < 1 && formData.gender == "female") {
    showWarning("Enter a weight above 0");
    return;
  }
  if (formData.inches < 0) {
    showWarning("Enter a valid height");
    return;
  }
  if (formData.age < 1 || formData.age > 100) {
    showWarning("Enter a valid age");
    return;
  }
  hideWarning();

  // Update the previous form data
  previousFormData = { ...formData };
  console.log(formData);
  if (formData.gender == "male") {
    const perc = calculateMalePercentage(
      parseFloat(formData.inches),
      parseFloat(formData.waist),
      parseFloat(formData.neck)
    );

    updateBodyFatResults(perc, formData);
    maintenance.querySelector("span").innerHTML = perc.toFixed(2) + "% ±2";
  } else {
    const perc = calculateFemalePercentage(
      parseFloat(formData.inches),
      parseFloat(formData.waist),
      parseFloat(formData.neck),
      parseFloat(formData.hip)
    );

    updateBodyFatResults(perc, formData);
    maintenance.querySelector("span").innerHTML = perc.toFixed(2) + "% ±2";
  }

  aside.classList.add("active");
});

function updateBodyFatResults(perc, formData) {
  const decimalPerc = (perc / 100).toFixed(2);
  const leanM = formData.weight * (1 - decimalPerc);
  const fatM = formData.weight * decimalPerc;
  const waterM = formData.weight * 0.73;
  fatMass.children[1].innerHTML = fatM.toFixed(2) + " lbs";
  leanMass.children[1].innerHTML = leanM.toFixed(2) + " lbs";
  waterMass.children[1].innerHTML = waterM.toFixed(2) + " lbs";
}
function calculateMalePercentage(height, waist, neck) {
  let wmn = waist - neck;
  if (wmn === 0) {
    wmn += 1;
  }
  return 86.01 * Math.log10(wmn) - 70.041 * Math.log10(height) + 36.76;
}
function calculateFemalePercentage(height, waist, neck, hip) {
  let wph = waist + hip - neck;
  if (wph == 0) {
    wph += 1;
  }
  return 163.205 * Math.log10(wph) - 97.684 * Math.log10(height) - 78.387;
}
function getBaseLog(x, y) {
  return Math.log(y) / Math.log(x);
}

function showWarning(message) {
  warning.innerHTML = message;
  warning.style.display = "block";
}
function hideWarning() {
  warning.style.display = "none";
}
